import { Route } from '@angular/router';
import { UnderConstructionPage } from '../../pages/status-pages/under-construction/under-construction.page';

export const UNDER_CONSTRUCTION_TITLE = "We're Building This Page";

export function legacyUnderConstruction(
  path: string,
  legacyUrl: string,
  title = UNDER_CONSTRUCTION_TITLE,
): Route {
  return {
    path,
    component: UnderConstructionPage,
    data: { legacyUrl },
    title,
  };
}
